/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_App_Search_DesktopInputs */

const en_nav_app_search_desktop = /** @type {(inputs: Nav_App_Search_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking for something?`)
};

const es_nav_app_search_desktop = /** @type {(inputs: Nav_App_Search_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Buscas algo?`)
};

/**
* | output |
* | --- |
* | "Looking for something?" |
*
* @param {Nav_App_Search_DesktopInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_app_search_desktop = /** @type {((inputs?: Nav_App_Search_DesktopInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_App_Search_DesktopInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_app_search_desktop(inputs)
	return en_nav_app_search_desktop(inputs)
});